export default "__VITE_ASSET__mmVdRMGj__"